<section class="theme-border gallery-wrapper">
    @for (row of rowData(); track row.uniqueId) {
        <app-card [row]="row" [columns]="columns()!" />
    }
</section>
